const faqDetails = document.querySelectorAll(".Faq.Detail");
const faqOverviews = document.querySelectorAll(".Faq.Overview");

if (faqDetails.length > 0 || faqOverviews.length > 0) {
	faqDetails.forEach(detail => {
		detail.querySelectorAll(".Faq.Item").forEach(item => {
			item.addEventListener("click", () => {
				item.classList.toggle("open");
			});
		});
	});

	faqOverviews.forEach(overview => {
		overview.querySelectorAll(".Faq.Item").forEach(item => {
			item.addEventListener("click", () => {
				item.classList.toggle("open");
			});
		});
	});

// Use this if using Ajax filtering -- Search and Filter Pro
	// (function ( $ ) {
	// 	"use strict";
	//
	// 	$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
	// 		if (faqDetail) {
	// 			Array.from(faqDetail.querySelectorAll(".Faq.Item")).forEach(item => {
	// 				item.addEventListener("click", () => {
	// 					!item.classList.contains("open") ? item.classList.add("open") : item.classList.remove("open");
	// 				});
	// 			});
	// 		}
	// 		if (faqOverview) {
	// 			Array.from(faqOverview.querySelectorAll(".Faq.Item")).forEach(item => {
	// 				item.addEventListener("click", () => {
	// 					!item.classList.contains("open") ? item.classList.add("open") : item.classList.remove("open");
	// 				});
	// 			});
	// 		}
	// 	});
	// }(jQuery));
}